import React from "react";
import LiveAuctionList from "./LiveAuctionList";
import { useDispatch, useSelector } from "react-redux";
import { getAllSellerLiveAuction } from "../../../redux/action/liveRoom";
import AllLiveAuctionFrame from "../../commanPage/liveRoom/AllLiveAuctionFrame";

function SellerTodayAuctions() {
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state?.profileStore);
  const { sellerLoading } = useSelector((state) => state.sellerLiveAuctionList);

  const handleReload = () => {
    dispatch(getAllSellerLiveAuction(profile?.organization));
  };

  return (
    <AllLiveAuctionFrame
      children={<LiveAuctionList />}
      handleReload={handleReload}
      ListLoadings={sellerLoading}
    />
  );
}

export default SellerTodayAuctions;
